import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { Button, HStack, Icon, VStack } from "native-base";
import React, { useState } from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";

import { SortTypesEnum } from "../types";

type SortCardProps = {
  onSelectSortOption: (option: SortTypesEnum) => void;
};

const SortCard = ({ onSelectSortOption }: SortCardProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <>
      <HStack my="2" py="2">
        <Button
          w="full"
          variant="outline"
          leftIcon={<Icon as={<MaterialIcons name="sort" />} color="primary.600" size="lg" />}
          onPress={() => setModalVisible(true)}>
          Ordenar
        </Button>
      </HStack>
      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        Header="Ordernar"
        Body={
          <VStack>
            <FormButton
              my="2"
              colorScheme="white"
              textColor="primary.600"
              leftIcon={
                <Icon
                  as={<MaterialCommunityIcons name="sort-alphabetical-variant" />}
                  color="primary.600"
                  size="lg"
                />
              }
              onPress={() => {
                onSelectSortOption(SortTypesEnum.NAME_DESC);
                setModalVisible(false);
              }}>
              Por nome
            </FormButton>
            <FormButton
              my="2"
              colorScheme="white"
              textColor="primary.600"
              leftIcon={
                <Icon
                  as={<MaterialCommunityIcons name="sort-numeric-variant" />}
                  color="primary.600"
                  size="lg"
                />
              }
              onPress={() => {
                onSelectSortOption(SortTypesEnum.PRICE_LOWER);
                setModalVisible(false);
              }}>
              Por preço
            </FormButton>
          </VStack>
        }
      />
    </>
  );
};

export default SortCard;
